const wowApp = require('angular').module('wowApp.wallet');

const { digitalPayErrorDisplayComponentDefinition } = require('./digital-pay-error-display.component');
const { digitalPayWarningDisplayComponentDefinition } = require('./digital-pay-warning-display.component');

const digitalPayErrorStampDefinition = require('./digital-pay-error-stamp.component');

const DigitalPayPaymentErrorDisplayService = require('./digital-pay-payment-error-display.service');
const DigitalPayErrorMessageGenerator = require('./digital-pay-error-message.generator');
const DigitalPayPaymentErrorStateService = require('../../digitalpay/services/digital-pay-payment-error-state.service');

wowApp.component('wowDigitalPayErrorDisplay', digitalPayErrorDisplayComponentDefinition);
wowApp.component('wowDigitalPayWarningDisplay', digitalPayWarningDisplayComponentDefinition);
wowApp.component('wowDigitalPayErrorStamp', digitalPayErrorStampDefinition);

/* TODO: Need Tech Debt story to remove reliance on DigitalPayPaymentErrorStateService and DigitalPayPaymentErrorDisplayService */
wowApp.service('DigitalPayPaymentErrorStateService', [DigitalPayPaymentErrorStateService]);
wowApp.service('DigitalPayPaymentErrorDisplayService', ['$timeout', 'MoveFocus', 'Settings', 'DigitalPayPaymentErrorStateService', 'DigitalPayErrorMessageGenerator', DigitalPayPaymentErrorDisplayService]);
wowApp.service('DigitalPayErrorMessageGenerator', ['Settings', DigitalPayErrorMessageGenerator]);



// WEBPACK FOOTER //
// ./src/wallet/error/index.js